import { render, staticRenderFns } from "./SwapBlock.vue?vue&type=template&id=a9427ddc&"
import script from "./SwapBlock.vue?vue&type=script&lang=js&"
export * from "./SwapBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports